import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import counterPageReducer from './containers/CounterPage/reducer';
import homePageReducer from './containers/HomePage/reducer';
import manualAccessPageReducer from './containers/ManualAccessPage/reducer';
import loginAutomatedPageReducer from './containers/LoginAutomatedPage/reducer';
import notifyAlertReducer from './containers/WithNotifyAlert/NotifyAlertProvider/reducer';

const containersReducer = {
  containers: combineReducers({
    counterPageReducer,
    homePageReducer,
    manualAccessPageReducer,
    loginAutomatedPageReducer,
    notifyAlertReducer
    // NOTE: put other app reducers here
  })
};

const createGlobalReducer = () => (
  combineReducers({
    ...containersReducer,
    route: routerReducer
  })
);

export default createGlobalReducer;



// WEBPACK FOOTER //
// ./src/global-reducer.js